export default () => ({
  tabs: [],
});
